(function () {
    "use strict";
    angular.module("app").controller("DossierCommentsController", DossierCommentsController);

    DossierCommentsController.$inject = ["$scope", "commentsService",];
    function DossierCommentsController($scope, commentsService) {
        const subscription = commentsService.Dossier$.subscribe(function onNext(d) { if (d) $scope.comments = d; });
        
        this.$onDestroy = function () {
            subscription.dispose();
        };
    }
})();